import type { CSSProperties, ReactNode } from 'react';

export type SummaryItem = { label: ReactNode; value: ReactNode; key?: string; labelStyle?: CSSProperties };
export type SummaryTotal = {
  label: ReactNode;
  value: ReactNode;
  /** `false` = valor sem `<b>` (ex.: selo "3 itens"). */
  bold?: boolean;
  valueStyle?: CSSProperties;
};

/** Linhas de resumo (`.sumrow`) com total opcional (`.sumrow.total`). */
export function SummaryList({ items, total }: { items: SummaryItem[]; total?: SummaryTotal }) {
  return (
    <>
      {items.map((it, i) => (
        <div className="sumrow" key={it.key ?? i}><span style={it.labelStyle}>{it.label}</span><span>{it.value}</span></div>
      ))}
      {total && (
        <div className="sumrow total">
          <span>{total.label}</span>
          {total.bold === false ? total.value : <b style={total.valueStyle}>{total.value}</b>}
        </div>
      )}
    </>
  );
}
